import { Link } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';

import { ErrorSection } from 'src/components/sections/ErrorSection';
import { Button } from 'src/components/ui/button';
import { ForecastDefaultRoute } from 'src/routes/forecast';

export function NotFoundPage(): ReactElement {
  const { user } = useAuth();
  const { t } = useTranslation('errors');

  return (
    <ErrorSection
      action={
        <Button>
          <Link to={user ? ForecastDefaultRoute.to : '/'}>
            {t('Go back to forecast')}
          </Link>
        </Button>
      }
      code={404}
      description={t('We could not find the page')}
      title={t('Page not found')}
    />
  );
}
